import { queryOptions } from '@tanstack/react-query'

import { getUser } from '@/services/fintalk/services/fintalk-backoffice/users/get'

import { COMPANIES_QUERY_KEYS } from '../companies'

export const USER_QUERY_KEYS = {
  root: () => ['user'] as const,

  scope: (userId: string) => [...USER_QUERY_KEYS.root(), userId] as const,
  // ex: ['user', '123']

  profile: (userId: string, companyId: string) =>
    [...COMPANIES_QUERY_KEYS.scope(userId, companyId), 'profile'] as const,
  // ex: ['user', '123', 'companies', '456', 'profile']
}

export const userQueryOptions = (companyId: string, userId: string) => {
  return queryOptions({
    queryKey: USER_QUERY_KEYS.profile(userId, companyId),
    queryFn: () => getUser(companyId, userId),
    staleTime: 5 * 60_000, // 5 minutes
  })
}
